module.exports = __webpack_public_path__ + "img/shoe-prints.d8448deb.svg";